// extracted by mini-css-extract-plugin
export var active = "_1w-7";
export var container = "_1w-0";
export var evenWidth = "_1w-4";
export var large = "_1w-5";
export var outlet = "_1w-8";
export var slide = "_1w-2";
export var small = "_1w-6";
export var tab = "_1w-3";
export var tabs = "_1w-1";